import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaChevronLeft } from "react-icons/fa";

const TechnicalModal = ({show }) => {
    return (
        <>
            <Modal dialogClassName="internet-modal" show={show} backdrop="static" keyboard={false} centered>
                <div className='mobile-view text-md-center'>
                    <div className='mobile-view-frame d-md-inline-block h-100 position-relative text-md-start'>
                        <div className='modal-view-frame'>
                            <Modal.Header>
                                <Modal.Title><h4 className="modal-title"></h4></Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="h-100 pt-0 pb-4 d-flex flex-column justify-content-center">
                                <div className="no-internet-content text-center">
                                    <h2 className='mb-1'>Temporary Technical Issue</h2>
                                    <p className="text-white fs-5 mb-4">We are currently unable to start app. Please try again in some time. Thanks for understanding</p>
                                </div>
                            </Modal.Body>
                        </div>
                        <img src="./images/other/mobile.png" className="default-mobile-frame pe-none position-relative h-100 d-none d-md-block" alt="Mobile" />
                    </div>
                </div>
            </Modal>
        </>
    )
}
export default TechnicalModal
